import React from 'react'

export default function FlipPDF () {
        return (
            <div style={{ paddingRight: '16px', paddingLeft: '16px', paddingTop: '84px', width:'100%' }}>
                <h1 style={{ textAlign: 'center' }}>2026 Product Catalogue in Flip PDF   |    Catalogue de produits 2026 en Flip PDF</h1>
                    <div style={{ textAlign:'center' }}>
                        <div style={{ display: 'inline-block', margin: 'auto', maxWidth:"500px" }}>
                            <a href="https://books.atlastrailer.com/books/B2B-2026-Complete-Catalogue/" target="_blank">
                                <img src="https://rvcatalogue.s3.us-east-1.amazonaws.com/Cover2026/WEB+2026+Atlas+Catalogue+Cover+English.jpg" style={{ display: 'inline-block', margin: 'auto', maxWidth:"500px" }} alt=''/>
                            </a>
                            <h1 style={{ textAlign: 'center' }}>English</h1>
                        </div>
                        <div style={{ display: 'inline-block', margin: 'auto', width:"100px" }}></div>
                        <div style={{ display: 'inline-block', margin: 'auto', maxWidth:"500px" }}>
                            <a href="https://books.atlastrailer.com/books/French-2026-Catalog/" target="_blank">
                                <img src="https://rvcatalogue.s3.us-east-1.amazonaws.com/Cover2026/WEB+2026+Atlas+Catalogue+Cover+French.jpg" style={{ display: 'inline-block', margin: 'auto', maxWidth:"500px" }} alt='' />
                            </a>
                            <h1 style={{ textAlign: 'center' }}>Français</h1> 

                        </div>
                    </div>
            </div>
        )
}
